import { useContext, useRef, useState } from "react";
import { GalleryPreviewContext, GalleryPreviewContextType } from "../context";
// import { ChevronLeft, ChevronRight, Copy, Download, Pencil } from "lucide-react";
import { Dialog, DialogContent } from "@/shared/ui/dialog.tsx";
import { Button } from "@/shared/ui/button";
import { ChevronLeftIcon, ChevronRight, Download, Loader, Loader2, Pause, Play, PlayIcon, Rss, Scan, SendHorizonal, Volume2, VolumeX, X } from "lucide-react";
import { Textarea } from "@/shared/ui/textarea";
import { Card, CardContent } from "@/shared/ui/card";
// import { Button } from "@/shared/ui/button.tsx";
import { useNavigate } from "react-router-dom";
import { useCreateStories } from "../api/story-creation";
import { useCreateVideo } from "../api/video-creation";
import { toast } from "sonner";
import { useAtomValue } from "jotai";
import { themeAtom } from "@/features/app-layout/atoms/theme-atoms";
const ImagePreview = () => {

  const {
    currentImageIndex,
    setOpenPreview,
    openPreview,
    nextImage,
    prevImage
  } = useContext<GalleryPreviewContextType>(GalleryPreviewContext)

  const navigate = useNavigate()

  const videoRef = useRef<HTMLVideoElement>(null)

  const [isPlaying, setIsPlaying] = useState(true)

  const [muted, setMuted] = useState(true)

  // const [playback, setPlayBack] = useState([0])

  // const animationRef = useRef<number | null>(null)

  // useEffect(() => {
  //   const video = videoRef.current
  //   if (!video) return

  //   const updatePlayback = () => {
  //     setPlayBack([video.currentTime])
  //     animationRef.current = requestAnimationFrame(updatePlayback)
  //   }

  //   if (isPlaying) {
  //     animationRef.current = requestAnimationFrame(updatePlayback)
  //   } else if (animationRef.current) {
  //     cancelAnimationFrame(animationRef.current)
  //   }

  //   return () => {
  //     if (animationRef.current) cancelAnimationFrame(animationRef.current)
  //   }
  // }, [isPlaying])



  // useEffect(() => {
  //   const video = videoRef.current;
  //   if (!video) return;

  //   const handleTimeUpdate = () => {
  //     setPlayBack([video.currentTime]);
  //   };

  //   video.addEventListener('timeupdate', handleTimeUpdate);

  //   return () => {
  //     video.removeEventListener('timeupdate', handleTimeUpdate);
  //   };
  // }, []);

  const { createStory, status } = useCreateStories()


  const theme = useAtomValue(themeAtom)

  const { mutate: generateVideo, status: videoJobStatus } = useCreateVideo()

  return (
    <Dialog open={openPreview} onOpenChange={() => setOpenPreview(false)} modal>
      <DialogContent className="w-screen h-screen max-w-screen-2xl p-0 outline-none border-0 bg-black/15 backdrop-blur-lg">
        <div className="size-full flex flex-col lg:flex-row items-center">
          <section className="w-full lg:w-4/5 h-full flex items-center justify-center relative">
            <Button
              onClick={() => setOpenPreview(false)}
              className="rounded-full size-6 absolute top-5 right-3 lg:right-5 z-50" variant="outline" size="icon"><X size={12} /></Button>
            <Button
              onClick={prevImage}
              className="rounded-full size-6 absolute top-[50%] -translate-y-[50%] left-5" variant="outline" size="icon"><ChevronLeftIcon size={12} /></Button>
            <Button
              onClick={nextImage}
              className="rounded-full size-6 absolute top-[50%] -translate-y-[50%] right-5"
              variant="outline" size="icon">
              <ChevronRight size={12} /></Button>
            {currentImageIndex?.catalog_item !== "video"
              ? <img
                src={currentImageIndex?.url}
                className="w-4/5 md:w-3/5 h-auto max-h-[60vh] lg:max-h-[90vh] object-contain rounded-xl"
              />
              : <>
                <video
                  ref={videoRef}
                  src={currentImageIndex?.url}
                  className="w-4/5 md:w-3/5 h-auto max-h-[90vh] object-contain rounded-xl"
                  autoPlay playsInline muted={muted} loop
                />
                <div className="absolute bottom-2 flex items-center justify-center gap-2 w-4/5 md:w-3/5 rounded-full">
                  <Button size="icon"
                    onClick={() => {
                      if (!isPlaying) {
                        videoRef.current?.play()
                        setIsPlaying(true)
                      } else {
                        videoRef.current?.pause()
                        setIsPlaying(false)
                      }
                    }}
                    variant="outline" className="rounded-full">
                    {isPlaying ? <Pause /> : <PlayIcon />}
                  </Button>
                  {/*
                    <Slider className="flex-1"
                      value={playback}
                      max={videoRef.current?.duration}
                      onValueCommit={(value) => {
                        if (videoRef.current) {
                          videoRef.current.currentTime = value[0]
                        }
                      }}
                      onValueChange={(val: number[]) => setPlayBack(val)} />
                  */}
                  <Button size="icon"
                    onClick={() => {
                      setMuted(prev => !prev);
                    }}
                    variant="outline" className="rounded-full">
                    {muted ? <VolumeX /> : <Volume2 />}
                  </Button>
                </div>
              </>
            }
          </section>
          <section className="w-full lg:w-1/5 h-1/3 lg:h-full bg-white p-4 flex flex-col gap-4 justify-between">
            <div className="grid grid-cols-2 lg:grid-cols-1 grid-rows-4 gap-3">
              {currentImageIndex?.catalog_item !== "video" &&
                <>
                <Card
                  onClick={() => {
                    if (currentImageIndex
                      && theme.isVideoClient
                      && currentImageIndex.catalog_item !== "video"
                      && videoJobStatus !== "pending") {
                      generateVideo({
                        image_id: currentImageIndex.id,
                        description: ""
                      })
                    } else {
                      toast.message("Coming soon 🎃...")
                    }
                  }}
                  className="rounded-xl overflow-hidden shadow shadow-purple-100 h-24 w-full relative cursor-pointer col-span-2 lg:col-span-1 row-span-2">
                  <video
                    className="absolute top-0 left-0 z-0 w-full h-full object-cover rounded-xl"
                    src="https://86v8u6agau.ufs.sh/f/A17KOoeuO4h92XUNPcokEUzlDbvu9tyQFOMApJ7Ngin8RdaI" // replace with your video URL
                    autoPlay
                    loop
                    muted
                    playsInline
                  />
                  <div className="absolute inset-0 bg-black/50 z-10" />
                  <Button className="size-9 bg-white/10 z-20 backdrop-blur absolute top-2 right-2 border border-purple-100 rounded-full" size="icon" variant="outline">
                    {videoJobStatus === "pending"
                      ? <Loader className="animate-spin text-white" />
                      : <Play size={12} className="text-white" />}
                  </Button>
                  <CardContent className="flex relative text-white z-50 flex-col justify-end size-full font-montserrat font-bold tracking-wide">
                    Generate Video
                    {videoJobStatus === "pending" &&
                      <span className="ps-2 text-white/80 font-poppins tracking-wide text-xs font-bold z-50">Starting video engine...</span>
                    }
                  </CardContent>
                </Card>
                <Button
                  onClick={() => {
                    if (currentImageIndex) {
                      createStory({ image_id: currentImageIndex.id, description: "" })
                    }
                  }}
                  variant="outline"
                  className="rounded-full font-poppins text-xs lg:text-sm tracking-wide size-full border border-purple-500 flex items-center justify-between gap-2"
                > {status === "pending"
                    ? <> Generating... <Loader2 className="animate-spin" /></>
                    : <>Generate Theme <Rss strokeWidth={3} /></>

                  }</Button>
                <Button
                  onClick={() => {
                    if (currentImageIndex) {
                      navigate(`/home/gallery/${currentImageIndex.id}`)
                    }
                  }}
                  variant="outline"
                  className="rounded-full text-xs lg:text-sm font-poppins tracking-wide size-full border border-purple-500 flex items-center justify-between gap-2"
                > Edit Image <Scan strokeWidth={3} /> </Button>
              </> }
              <Button
                onClick={() => {
                  if (currentImageIndex) {
                    const link = document.createElement('a');
                    link.href = currentImageIndex.url;
                    link.download = currentImageIndex?.url.split('/').pop() || 'image';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                  }
                }}
                variant="outline"
                className="rounded-full text-xs lg:text-sm font-poppins tracking-wide size-full border border-purple-500 flex items-center justify-between gap-2"
              > Save to device <Download strokeWidth={3} /> </Button>
            </div>
            <div className="lg:flex flex-col items-end gap-1 bg-gray-300  p-3 rounded-xl hidden">
              <Textarea className="bg-transparent shadow-none resize-none w-full font-poppins text-sm border-0 focus:ring-0 focus:outline-none focus:border-0 focus-visible:ring-0" placeholder="Add feedback" />
              <Button size="icon" variant="ghost"><SendHorizonal /></Button>
            </div>
          </section>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default ImagePreview;
